export default {
  activeShippingProvidersLabel: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery.active_shipping_providers.label',
    defaultMessage: 'Active shipping providers:',
  },
  activeShippingProvidersTag: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery.active_shipping_providers.tag',
    defaultMessage: '{weekday}: {activeShippingProviders}',
  },
}
